export default "__VITE_ASSET__Pm00T_OE__"